(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oracle-cart-summary')) {
    customElements.define('oracle-cart-summary', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.header = this.querySelector('summary');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.mobileOpen = this.details.open;
        this.onLayout = () => {
          this.details.open = this.desktop.matches || this.mobileOpen;
        };
        this.onToggle = () => {
          if (this.desktop.matches) {
            if (!this.details.open) this.details.open = true;
          } else {
            this.mobileOpen = this.details.open;
          }
        };
        this.onHeaderClick = (event) => {
          if (this.desktop.matches) event.preventDefault();
        };
        this.desktop.addEventListener('change', this.onLayout);
        this.details.addEventListener('toggle', this.onToggle);
        this.header.addEventListener('click', this.onHeaderClick);
        this.onLayout();

        this.events = ['summary1:refresh', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added'];
        this.onRefresh = () => {
          this.request?.abort();
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 120);
        };
        this.onPageShow = (event) => { if (event.persisted) this.onRefresh(); };
        this.events.forEach((name) => document.addEventListener(name, this.onRefresh));
        window.addEventListener('focus', this.onRefresh);
        window.addEventListener('pageshow', this.onPageShow);
        this.connectDawn = () => {
          if (!this.unsubscribeCart && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onRefresh);
          }
        };
        this.connectDawn();
        if (document.readyState !== 'complete') window.addEventListener('load', this.connectDawn, { once: true });
      }

      disconnectedCallback() {
        this.desktop.removeEventListener('change', this.onLayout);
        this.details.removeEventListener('toggle', this.onToggle);
        this.header.removeEventListener('click', this.onHeaderClick);
        this.events.forEach((name) => document.removeEventListener(name, this.onRefresh));
        window.removeEventListener('focus', this.onRefresh);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('load', this.connectDawn);
        this.unsubscribeCart?.();
        this.unsubscribeCart = null;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
      }

      async refresh() {
        if (!this.isConnected) return;
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        this.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => request.abort(), 10000);
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', this.dataset.sectionId);
          url.hash = '';
          const response = await fetch(url, { signal: request.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('Section request failed');
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Section unavailable');
          const next = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
          const nextBody = next?.querySelector('.ocs-summary-body');
          const nextTotal = next?.querySelector('.ocs-header-total');
          if (!nextBody || !nextTotal) throw new Error('Summary incomplete');
          if (!this.isConnected || request.signal.aborted || this.request !== request) return;
          // Remplacer uniquement le résumé : ne jamais recharger le paiement Whop.
          const body = this.querySelector('.ocs-summary-body');
          const total = this.querySelector('.ocs-header-total');
          const activeLink = body.contains(document.activeElement) ? document.activeElement.closest('a') : null;
          const activeHref = activeLink?.getAttribute('href');
          if (body.innerHTML !== nextBody.innerHTML) {
            body.innerHTML = nextBody.innerHTML;
            if (activeLink) {
              const replacement = Array.from(body.querySelectorAll('a')).find((link) => link.getAttribute('href') === activeHref);
              (replacement || this.header).focus({ preventScroll: true });
            }
          }
          if (total.innerHTML !== nextTotal.innerHTML) total.innerHTML = nextTotal.innerHTML;
          this.removeAttribute('data-refresh-error');
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.setAttribute('data-refresh-error', 'true');
            console.warn('[Checkout summary] Cart refresh failed.', error);
          }
        } finally {
          clearTimeout(timeout);
          if (this.request === request) {
            this.removeAttribute('aria-busy');
            this.request = null;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["confirmation1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('confirmation-one')) {
    customElements.define('confirmation-one', class extends HTMLElement {
      connectedCallback() {
        // Un paramètre d'URL n'est pas une preuve de paiement.
        // Il sert uniquement à afficher un retour d'erreur adapté.
        const status = new URLSearchParams(window.location.search).get('status');
        const hasError = status === 'error';
        this.dataset.returnState = hasError ? 'error' : 'neutral';
        this.querySelector('[data-confirmation-panel]').hidden = hasError;
        this.querySelector('[data-error-panel]').hidden = !hasError;

        this.querySelectorAll('[data-step]').forEach((step) => {
          const number = Number(step.dataset.step);
          const activeStep = hasError ? 2 : 3;
          step.classList.toggle('is-complete', number < activeStep);
          step.classList.toggle('is-current', number === activeStep);
          if (number === activeStep) {
            step.setAttribute('aria-current', 'step');
          } else {
            step.removeAttribute('aria-current');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-research-gate')) {
    class CartResearchGate extends HTMLElement {
      constructor() {
        super();

        this.updateButton = this.updateButton.bind(this);
        this.observer = new MutationObserver(this.updateButton);
      }

      connectedCallback() {
        this.addEventListener('input', this.updateButton);
        this.addEventListener('change', this.updateButton);
        window.addEventListener('pageshow', this.updateButton);

        this.observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'value',
            'checked',
            'selected',
            'disabled',
            'required'
          ]
        });

        queueMicrotask(this.updateButton);
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.updateButton);
        this.removeEventListener('change', this.updateButton);
        window.removeEventListener('pageshow', this.updateButton);
        this.observer.disconnect();
      }

      updateButton() {
        const button = this.querySelector('.cart-research__submit');

        if (!button) return;

        const fields = Array.from(
          this.querySelectorAll('input[required], select[required]')
        );

        const complete =
          fields.length === 4 &&
          fields.every((field) => {
            if (field.disabled || !field.validity.valid) {
              return false;
            }

            if (field.type === 'checkbox') {
              return field.checked;
            }

            return field.value.trim() !== '';
          });

        if (button.disabled !== !complete) {
          button.disabled = !complete;
        }
      }
    }

    customElements.define('cart-research-gate', CartResearchGate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summary1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('summary-one')) {
    customElements.define('summary-one', class extends HTMLElement {
      connectedCallback() {
        this.refreshEvents = ['summary1:refresh', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added'];
        this.onRefresh = () => {
          // Cancel an older response immediately so it cannot overwrite newer cart data.
          this.request?.abort();
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 120);
        };
        this.onPageShow = (event) => { if (event.persisted) this.onRefresh(); };
        this.refreshEvents.forEach((name) => document.addEventListener(name, this.onRefresh));
        window.addEventListener('focus', this.onRefresh);
        window.addEventListener('pageshow', this.onPageShow);

        // Dawn publishes successful cart updates through its pub/sub helpers.
        this.connectDawn = () => {
          if (!this.unsubscribeCart && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onRefresh);
          }
        };
        this.connectDawn();
        if (document.readyState !== 'complete') window.addEventListener('load', this.connectDawn, { once: true });
      }

      disconnectedCallback() {
        this.refreshEvents.forEach((name) => document.removeEventListener(name, this.onRefresh));
        window.removeEventListener('focus', this.onRefresh);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('load', this.connectDawn);
        if (this.unsubscribeCart) this.unsubscribeCart();
        this.unsubscribeCart = null;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
      }

      async refresh() {
        if (!this.isConnected) return;
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        this.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => request.abort(), 10000);

        try {
          // Preserve the current locale, template context, and theme preview query.
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', this.dataset.sectionId);
          url.hash = '';
          const response = await fetch(url.toString(), {
            signal: request.signal,
            credentials: 'same-origin',
            cache: 'no-store'
          });
          if (!response.ok) throw new Error('Section request failed: ' + response.status);
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Section is unavailable');
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const next = parsed.getElementById(this.id);
          const nextBody = next?.querySelector('.s1-body');
          const nextTotal = next?.querySelector('.s1-total');
          if (!nextBody || !nextTotal) throw new Error('Section markup is incomplete');
          if (!this.isConnected || request.signal.aborted || this.request !== request) return;

          // Keep the summary element and its open state, keyboard focus, and live region.
          const body = this.querySelector('.s1-body');
          const total = this.querySelector('.s1-total');
          const activeLink = body.contains(document.activeElement) ? document.activeElement.closest('a') : null;
          const activeHref = activeLink?.getAttribute('href');
          if (body.innerHTML !== nextBody.innerHTML) {
            body.innerHTML = nextBody.innerHTML;
            if (activeLink) {
              const replacement = Array.from(body.querySelectorAll('a')).find((link) => link.getAttribute('href') === activeHref);
              (replacement || this.querySelector('.s1-header')).focus({ preventScroll: true });
            }
          }
          if (total.innerHTML !== nextTotal.innerHTML) total.innerHTML = nextTotal.innerHTML;
          this.removeAttribute('data-refresh-error');
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.setAttribute('data-refresh-error', 'true');
            console.warn('[Summary1] Cart refresh failed.', error);
          }
        } finally {
          clearTimeout(timeout);
          if (this.request === request) {
            this.removeAttribute('aria-busy');
            this.request = null;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
